<template>
    <!-- home -->
    <div v-show="!isShowNoData" class="hkfc-linup__wrapper">
        <template v-for="(team,index) in displayTeams" :key="index">
            <div class="hkfc-lineup__container">
                <div :class="`hkfc-lineup__header hkfc-lineup__${team}`">{{  lineupData.lineUpField[team].teamName }}</div>
                <div class="hkfc-lineup__body">
                    <div class="hkfc-lineup__card">
                        <div class="hkfc-lineup__body__header">
                            <div class="hkfc-lineup__shirt">{{ $t("SHIRT") }}</div>
                            <div class="hkfc-lineup__player">{{ $t("PLAYER") }}</div>
                            <div class="hkfc-lineup__position">{{ $t("POSITION") }}</div>
                        </div>

                        <div class="hkfc-lineup__row" v-for="(o,index) in lineupData.lineUpField[team].matchLineUps" :key="index">
                            <div class="hkfc-lineup__shirt">{{ o.number }}</div>
                            <div class="hkfc-lineup__player" :title="o.nameEn"><Navigation :id="o.playerId" :category="'player'" :name="o.nameEn"  class="field-player__row-container pe-none"><p>{{o.nameEn}}</p></Navigation></div>
                            <div class="hkfc-lineup__position">{{ $t(formatPositionName(o)) }}</div>                                  
                        </div>
                    </div>
                </div>     
            </div>
        </template>
        <!-- coach -->
        <div class="hkfc-lineup__coach__wrapper">
            <div class="hkfc-lineup__coach-header">
                <Navigation :id="matchDetailScore.homeTeamId" class="pe-none" :category="'team'" :name="matchDetailScore.homeTeamName">
                    <Icon  :logoUrl=matchDetailScore.homeLogo   ></Icon>
                </Navigation>
                <div>{{$t('COACHS')}}</div>
                <Navigation :id="matchDetailScore.awayTeamId"  class="pe-none" :category="'team'" :name="matchDetailScore.awayTeamName">
                    <Icon :logoUrl=matchDetailScore.awayLogo ></Icon>
                </Navigation>
            </div>
            <div class="hkfc-lineup__coach-body">
                <div>{{ formatCoachName(lineupData.coaches.home.coachName) }}</div>
                <div>{{ formatCoachName(lineupData.coaches.away.coachName) }}</div>
            </div>
        </div>
    </div>
    <div class="no-data" v-show="isShowNoData">{{$t('NO_LINEUPS')}}</div>
</template>

<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
export default {
    data() {
        return {
            isShowNoData: true,
            displayTeams: [
                "home",
                "away"
            ],
            lineupData: {
                lineUpField: {
                    away: [],
                    home: []
                },
                coaches: {
                    away: {},
                    home: {}
                }
            },
            isSkeletonLoading: {
                lineUp: false,
            },
        }
    },
    watch: {
        manualRefreshMatchDetail: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getHKFCMatchDetailLineUpData();
                }
            }
        }
    },
      computed:{
          ...mapGetters([              
                'isMobile',
                'matchDetailScore',
                'currentSportType',
                'currentLocale',
                'manualRefreshMatchDetail',
           ]),
    },
    mounted() {
        this.init();  
        this.getHKFCMatchDetailLineUpData();
    },
    methods: {
        ...mapMutations([
            "MANUAL_REFRESH_MATCH_DETAIL",
        ]),
        ...mapActions([
			"getHKFCMatchDetailLineUp",
		]),
        init() {
             this.matchId = this.$route.params.matchId;   
        },
        async getHKFCMatchDetailLineUpData() {
             let params = {
                matchId: this.matchId
            }
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.lineUp = true;
            }
            const result=  await this.getHKFCMatchDetailLineUp(params);
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.lineUp = false;
                this.verifyIfAllAPICallsDone();
            }
            if (result.result) {
                this.lineupData = result.result;
                this.isShowNoData = false;
            } else {
                this.isShowNoData = true;
            }
            
        },

        formatPositionName(o) {
            const positionName = {
                "GK" : "GOAL_KEEPERS",
                "DF" : "DEFENDERS",
                "DM" : "DEFENSIVE_MIDFIELDER",
                "MF" : "MIDFIELDERS",
                "AM" : "ATTACKER_MIDFILDER",
                "FW" : "FORWARD"
            }

            let result = positionName[o.positionCode] ? positionName[o.positionCode] : "-" ;
            
            return result
        },  

        formatCoachName(o) {
          return  o ? o : "-"
        },
        verifyIfAllAPICallsDone() {
            if (!this.isSkeletonLoading.lineUp) {
                this.MANUAL_REFRESH_MATCH_DETAIL();
            }
        },
    },
}
</script>

<style scoped>
.hkfc-linup__wrapper{
    display: flex;
}
.hkfc-lineup__container{
    margin-right: 38px;
}
.hkfc-lineup__header{
    margin-bottom: 12.5px;
    padding-left: 16px;;
}
.hkfc-lineup__body__header{
    display: flex;
    background: var(--color-theme);
    padding: 4.5px 16px;
    color: white;
    font-size: 14px;
}
.hkfc-lineup__shirt{
    width: 48px;
}
.hkfc-lineup__player{
    width: 195px;  
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.hkfc-lineup__position{
   text-align: center;
   width: 100px;
}
.hkfc-lineup__row{
    display: flex;
    padding: 17.5px 16px;
    border-bottom: 1px solid #35454D;
    font-size: 14px;
    align-items: center;
    pointer-events: none;
}
.hkfc-lineup__row:last-of-type{
    border-bottom: none;
}

/* coach */
.hkfc-lineup__coach__wrapper{
    width: 260px;
    margin-left: 100px;
}
.hkfc-lineup__coach-header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
}
.hkfc-lineup__coach-body{
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #CFD9DE;
}

@media (max-width: 768px ){
    .hkfc-linup__wrapper{
        flex-direction: column;
    }
    .hkfc-lineup__container{
        margin-right: 0;
    }
    .hkfc-lineup__coach__wrapper{
        margin-left: 0;
    }
    .hkfc-lineup__body__header{
        font-size: 11px;
        padding: 21.5px 16px;
    }
    .hkfc-lineup__row:last-of-type{
        border-bottom: 1px solid #35454D;
    }
    .hkfc-lineup__header{
        font-size: 11px;
        margin-bottom: 16px;
    }
    .hkfc-lineup__coach__wrapper{
        width: 100%;
        padding: 33.5px 58px 0;
        box-sizing: border-box;
    }
    .hkfc-lineup__away{
        margin-top: 29px;
    }
}
</style>